var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnergySoldGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.294 6.23013L10.4769 5.31138L11.7631 2.70825H20.4096L21.706 5.31138L19.889 6.21992L19.154 4.74992H13.029L12.294 6.23013ZM22.8494 8.83325H18.225L17.4185 5.77075H14.7644L13.9375 8.83325H9.34375L8.02688 11.4364L9.85417 12.3449L10.5994 10.8749H21.5938L22.3185 12.3551L24.1458 11.4466L22.8494 8.83325ZM21.9817 23.1249H19.8685L19.6235 22.2062L16.0915 16.8978L12.5492 22.2062L12.3144 23.1249H10.2013L13.1515 11.8958H15.2646L14.8971 13.2739L16.0915 15.0603L17.2756 13.2739L16.9183 11.8958H19.0417L21.9817 23.1249ZM15.4688 15.9791L14.5602 14.601L13.3556 19.1743L15.4688 15.9791ZM18.8273 19.1641L17.6227 14.5908L16.704 15.9791L18.8273 19.1641ZM9.85417 16.9999L5.77083 12.9166V15.9791H1.6875V18.0208H5.77083V21.0833L9.85417 16.9999Z",
    fill: "#2B8D3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergySoldGrid);
export default __webpack_public_path__ + "static/media/energy_sold_grid.6f1251ce843dbd07e07083f736c2df46.svg";
export { ForwardRef as ReactComponent };